import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { works } from "@/mocks/works";

export default function RankingPreview() {
  const top = [...works].sort((a, b) => b.score - a.score).slice(0, 6);

  const rankBadge = (i: number) =>
    i < 3
      ? "bg-gradient-to-br from-secondary-400 to-primary-500 text-background-50"
      : "bg-background-200 text-foreground-500";

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionTitle
        eyebrow="实时榜单"
        title="热门排行 TOP6"
        desc="根据站内口碑与热度综合排序，实时更新的热门作品榜单，帮你快速定位当下值得追的佳作。"
        moreTo="/ranking"
      />

      <div className="grid gap-4 md:grid-cols-2">
        {top.map((w, i) => (
          <Link
            key={w.id}
            to={`/works/${w.id}`}
            className="group flex items-center gap-4 rounded-2xl bg-background-100 p-4 ring-1 ring-background-300/60 transition-all hover:-translate-y-0.5 hover:ring-primary-500/60"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-lg ${rankBadge(i)}`}
            >
              {i + 1}
            </span>
            <img
              src={w.image}
              alt={`${w.title} 排行海报`}
              title={w.title}
              className="h-20 w-14 shrink-0 rounded-lg object-cover object-top"
            />
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-primary-400">
                {w.title}
              </h3>
              <p className="mt-0.5 text-xs text-foreground-500">
                {w.category}番 · {w.year}
              </p>
              <div className="mt-2 flex items-center gap-2">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`h-full rounded-full ${
                      i < 3 ? "bg-gradient-to-r from-secondary-400 to-primary-500" : "bg-accent-500"
                    }`}
                    style={{ width: `${(w.score / 10) * 100}%` }}
                  />
                </div>
                <span className="whitespace-nowrap text-xs font-bold text-secondary-400">{w.score.toFixed(1)}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}